import { toast } from 'sonner'
import {
  readDesktopNotificationPermission,
  requestDesktopNotificationPermission,
  showDesktopNotification,
} from '@/shared/lib/browser-notification'
import type { InAppNotification } from '../api/notifications-types'
import { resolveNotificationHref } from './resolve-notification-href'

export type LiveNotificationOpen = (notification: InAppNotification) => void

/** Windows / OS notification tray, including while this tab is open. */
export function shouldShowOsNotification(): boolean {
  return readDesktopNotificationPermission() === 'granted'
}

function postToTray(notification: InAppNotification, open: LiveNotificationOpen): void {
  showDesktopNotification({
    title: notification.title,
    body: notification.body,
    tag: notification.id,
    onClick: () => open(notification),
  })
}

export function presentLiveNotification(
  notification: InAppNotification,
  open: LiveNotificationOpen,
): void {
  const href = resolveNotificationHref(notification.actionUrl)
  const openAction =
    href.kind === 'none'
      ? undefined
      : {
          label: 'Open',
          onClick: () => open(notification),
        }
  const permission = readDesktopNotificationPermission()
  const allowAction =
    permission === 'default'
      ? {
          label: 'Allow notification tray',
          onClick: () => {
            void requestDesktopNotificationPermission().then((next) => {
              if (next === 'granted') postToTray(notification, open)
            })
          },
        }
      : undefined

  toast(notification.title, {
    description: notification.body,
    ...(allowAction
      ? {
          action: allowAction,
          ...(openAction ? { cancel: openAction } : {}),
        }
      : openAction
        ? { action: openAction }
        : {}),
  })

  if (permission === 'granted') postToTray(notification, open)
}
